import React, { Fragment } from 'react';
import Container from "../../components/container/container-component";
import SideContainer from "../../components/side-container/side-container-component";
import "./report.css";
import ReportInfo from "../report-info/report-info-container";
import Charts from "../charts/charts-container";
import Filters from "../filters/filters-container";
import MainContainer from "../../components/main-container/main-container-component";
import Responses from "../responses/responses-container";


const ReportComponent = (
  {
    reportUrl
  }
) => {
  return (
    <Container
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
    >
      {
        reportUrl
        ?
          <Fragment>
            <SideContainer>
              <Filters />
            </SideContainer>

            <MainContainer>

              <div className="report_info_container">
                <ReportInfo />
              </div>

              <div className="report_charts">
                <Charts />
              </div>

              <div className="report_responses">
                <Responses/>
              </div>

            </MainContainer>
          </Fragment>
          :
          <span style={{alignSelf: 'center'}}>Report url should be provided</span>
      }
    </Container>
  )
};

export default ReportComponent;


// WEBPACK FOOTER //
// ./src/modules/report/report-component.js